module.exports = __webpack_public_path__ + "img/2020_12_04_balloons.2a64eb93.jpg";